import * as Utils from '../Utils';
import {validate} from '../../privates/validations/validation';
import * as members from '../../privates/privateMembers';

/**
 * @mixin ReadOnlyMixin
 * @summary Provides functionality for input elements which support readonly mode.
 * @memberof $w
 */
class ReadOnlyMixin {

    /**
     * @member readOnly
     * @label property
     * @summary Sets or gets if a user can modify the value of the input element.
     * @description
     *  Setting the value of the `readOnly` property to `true` prevents users
     *  from changing the element's value. However, it does not limit your
     *  ability to change the value programmatically. Setting it to `false`
     *  allows users to change the element's value.
     *
     *  Getting the value of the `readOnly` property returns whether a user
     *  can modify the value of the input element.
     *
     *  You can also set an element's `readOnly` property in the Editor using the Settings pane:
     * 
     *  ![Input Settings pane](images/input_settings-read_only.png)
     * @snippet [ReadOnlyMixin-readonly_get.es6=Get whether the element is readOnly]
     * @snippet [ReadOnlyMixin-readonly_set.es6=Set an element to be readOnly]
     * @type {external:Boolean}
     * @memberof $w.ReadOnlyMixin
     */
    get readOnly() {
        return Utils.getProp(this, 'readOnly') || false;
    }

    /**
     * @member readOnly
     * @memberof $w.ReadOnlyMixin
     * @param {external:Boolean} readonly `true` if read-only.
     */
    set readOnly(readonly) {
        const compType = members._type.get(this).compType;
        if (!validate({
            compType,
            functionName: 'readonly',
            dataToValidate: {readonly},
            compName: this.id
        })) {
            return;
        }
        Utils.setProp(this, { readOnly: readonly });
    }
}

export default ReadOnlyMixin;
